import { useState } from "react";
import { useApi } from "@/hooks/useApi";
import { PageHeader, FilterBar, DataTable, ErrorBox } from "@/components/common/ui-bits";
import { fmtDateTime, ROLE_LABELS, optionList } from "@/lib/format";

const ENTITIES = ["usuario", "prospecto", "cliente", "servicio", "caso_fiscal", "cotizacion", "propuesta", "proyecto", "tarea", "plantilla", "documento", "solicitud"];

export default function Audit() {
  const [q, setQ] = useState("");
  const [f, setF] = useState({});
  const { data, loading, error } = useApi("/audit", { q, ...f });
  const [open, setOpen] = useState(null);
  return (
    <div>
      <PageHeader title="Historial de actividad" subtitle="Usuario, fecha y hora de cada cambio importante (America/Chicago)." />
      <FilterBar search={q} onSearch={setQ} values={f} onChange={setF} testid="audit-filters" filters={[{ key: "entity_type", label: "Módulo", options: optionList(ENTITIES) }]} />
      <ErrorBox text={error} />
      <DataTable testid="audit-table" loading={loading} rows={data} onRowClick={(r) => setOpen(open === r.id ? null : r.id)} empty="Sin actividad."
        columns={[{ key: "at", label: "Fecha y hora", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDateTime(r.at)}</span> },
          { key: "user_name", label: "Usuario", render: (r) => <span>{r.user_name}<span className="block text-xs text-slate-400">{ROLE_LABELS[r.role] || r.role}</span></span> },
          { key: "entity_type", label: "Módulo" }, { key: "action", label: "Acción" },
          { key: "summary", label: "Detalle", render: (r) => <div>{r.summary}{open === r.id && Object.keys(r.changes || {}).length > 0 && (
            <pre className="mt-2 max-w-xl overflow-x-auto whitespace-pre-wrap rounded bg-slate-50 p-2 text-[11px] text-slate-600" data-testid={`audit-changes-${r.id}`}>{JSON.stringify(r.changes, null, 2)}</pre>)}</div> }]} />
    </div>
  );
}
